exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  padding: 10px;\n  color: white;\n}\n\n\n.header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 10px;\n  margin-bottom: 10px;\n  background-color: #113972;\n}\n\n.header .logo{\n  height: 42px;\n  width: auto;\n  display: block;\n  margin: auto;\n}\n.header .title{\n    text-align: center;\n    width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 400
// module chunks = 2